export const PHILOSOPHY_QUOTE = (
  <>
    &quot;Modern music must pass through
    <br />
    <em className="text-muted">the creator&apos;s own heart.&quot;</em>
  </>
);

export interface PhilosophyCard {
  title: string;
  body: string;
}

export const PHILOSOPHY_CARDS: PhilosophyCard[] = [
  {
    title: "Heart Over Perfection",
    body: "Modern music must pass through the creator's own heart and lived experience. Without that it is just sound. I believe in honesty over perfection and in carrying something real into every track.",
  },
  {
    title: "Older Than Us",
    body: "I am drawn to what is older than us — rhythms that feel instinctive, almost remembered rather than learned. Something placed in us by nature itself, waiting to be woken.",
  },
  {
    title: "Awaken the Elemental",
    body: "I want to awaken something elemental. Not to explain or to instruct — but to reach the part of the listener that exists below thought, below language.",
  },
];
